import apiClient from "./client";

export async function updateMyCommunityProfile(payload) {
  const response = await apiClient.patch("me/community-profile/", payload);
  return response.data;
}

export async function uploadMyAvatar(payload) {
  const formData = new FormData();
  formData.append("avatar", payload.file);
  formData.append("crop_x", String(payload.cropX));
  formData.append("crop_y", String(payload.cropY));
  formData.append("crop_zoom", String(payload.cropZoom));

  const response = await apiClient.post("me/avatar/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
}

export async function uploadMyProfileBackground(file) {
  const formData = new FormData();
  formData.append("background", file);

  const response = await apiClient.post("me/profile-background/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
}

export async function fetchPublicProfile(publicSlug, signal) {
  const response = await apiClient.get(`profiles/${publicSlug}/`, { signal });
  return response.data;
}

export async function fetchImageProposals(signal, params = {}) {
  const response = await apiClient.get("image-proposals/", { signal, params });
  return response.data;
}

export async function fetchVotingImageProposals(categorySlug, signal) {
  const response = await apiClient.get("image-proposals/", {
    signal,
    params: { category: categorySlug },
  });
  return response.data;
}

export async function createImageProposal(payload) {
  const formData = new FormData();
  formData.append("category_id", String(payload.categoryId));
  formData.append("answer", payload.answer);
  formData.append("source_url", payload.sourceUrl);
  formData.append("image", payload.file);

  const response = await apiClient.post("image-proposals/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
}

export async function checkImageProposalDuplicate({ categoryId, answer }, signal) {
  const response = await apiClient.get("image-proposals/check-duplicate/", {
    signal,
    params: {
      category_id: categoryId,
      answer,
    },
  });
  return response.data;
}

export async function voteImageProposal(proposalId, value) {
  const response = await apiClient.post(`image-proposals/${proposalId}/vote/`, {
    value,
  });
  return response.data;
}

export async function fetchModeratorApplications(signal) {
  const response = await apiClient.get("moderator-applications/", { signal });
  return response.data;
}

export async function createModeratorApplication(payload) {
  const response = await apiClient.post("moderator-applications/", {
    motivation: payload.motivation,
    category_ids: payload.categoryIds,
  });
  return response.data;
}

export async function voteModeratorApplication(applicationId, value) {
  const response = await apiClient.post(
    `moderator-applications/${applicationId}/vote/`,
    { value }
  );
  return response.data;
}
